/** UAT grant admin endpoints — create, update, list, revoke (admin portal). */
import { uatGrantListSchema, uatGrantRequestSchema, uatGrantUpdateSchema, uatMutationResultSchema, } from "@nook/schema";
/** Returns all UAT grants ordered by creation time, oldest first. */
export function listUatUsers(http) {
    return http.request({ path: "/v1/admin/users", schema: uatGrantListSchema });
}
/** Creates or updates a UAT grant by email; `409` if a newer operation supersedes it. */
export function grantUatUser(http, body) {
    return http.request({
        path: "/v1/admin/users",
        method: "POST",
        body: uatGrantRequestSchema.parse(body),
        schema: uatMutationResultSchema,
    });
}
/** Updates the expiry on an existing grant. */
export function grantUatUserById(http, id, body) {
    return http.request({
        path: `/v1/admin/users/${encodeURIComponent(id)}/grant`,
        method: "PATCH",
        body: uatGrantUpdateSchema.parse(body),
        schema: uatMutationResultSchema,
    });
}
/** Permanently removes a UAT grant without deleting the user's account. */
export function deleteUatUser(http, id) {
    return http.request({
        path: `/v1/admin/users/${encodeURIComponent(id)}`,
        method: "DELETE",
        schema: uatMutationResultSchema,
    });
}
/** Revokes the grant; `204`-style ack — backend answers `ok: true` either way. */
export function revokeUatUser(http, id) {
    return http.request({
        path: `/v1/admin/users/${encodeURIComponent(id)}/revoke`,
        method: "POST",
        schema: uatMutationResultSchema,
    });
}
//# sourceMappingURL=uat.js.map